import type { ReactNode } from 'react';
import { Button } from '../../primitives/Button.js';
import { Tooltip } from '../../primitives/Tooltip.js';
import { cx } from '../../utils/cx.js';
import styles from './DataTableSelectionBar.module.css';

export type DataTableSelectionDockActionProps = {
  /** Short visible label in the dock. */
  label: string;
  icon?: ReactNode;
  /** Longer hint for tooltip; defaults to `label`. */
  hint?: string;
  onClick?: () => void;
  disabled?: boolean;
  /** Primary CTA styling in the dock. */
  primary?: boolean;
};

export function DataTableSelectionDockAction({
  label,
  icon,
  hint,
  onClick,
  disabled,
  primary,
}: DataTableSelectionDockActionProps) {
  const tip = hint ?? label;
  const showTip = tip !== label;

  const button = (
    <Button
      type="button"
      size="xs"
      variant={primary ? 'primary' : 'secondaryPill'}
      disabled={disabled}
      onClick={onClick}
      aria-label={tip}
      className={cx(styles.dockAction, primary ? styles.dockActionPrimary : styles.dockActionSecondary)}
    >
      {icon ? <span className={styles.dockActionIcon}>{icon}</span> : null}
      <span className={styles.dockActionLabel}>{label}</span>
    </Button>
  );

  if (!showTip) return button;

  return (
    <Tooltip label={tip} position="top" portal>
      {button}
    </Tooltip>
  );
}
